import { createSlice } from "@reduxjs/toolkit";
import { getPrivacyPolicy, updatePrivacyPolicy } from "actions/privacyPolicy";

const initialState = {
  loading: false,
  privacyPolicy: null,
  updateLoading: false,
  error: null,
};

export const privacyPolicySlice = createSlice({
  name: "privacyPolicy",
  initialState,
  reducers: {
    clearPrivacyPolicy: (state) => {
      state.privacyPolicy = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getPrivacyPolicy.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPrivacyPolicy.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.privacyPolicy = payload;
      })
      .addCase(getPrivacyPolicy.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(updatePrivacyPolicy.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updatePrivacyPolicy.fulfilled, (state, { payload }) => {
        state.updateLoading = false;
        state.privacyPolicy = payload;
      })
      .addCase(updatePrivacyPolicy.rejected, (state, { payload }) => {
        state.updateLoading = false;
        state.error = payload;
      });
  },
});

export const { clearPrivacyPolicy, clearError } = privacyPolicySlice.actions;

export default privacyPolicySlice.reducer;
